import * as React from 'react';
import Badge from '@mui/material/Badge';
import { model, gtechurl, miurl, adsofturl } from '../config/config';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { CardActionArea } from '@mui/material';
import ContentModal from './ContentModal';
import { styled } from '@mui/material/styles';
import { useNavigate } from "react-router-dom";

export default function ColorBadge(props) {
    
	let wfheight = 0;
	let finalurl = "";
	let endurl = "";
	if( model.includes("gts") || model.includes("bip") || model === "active")
	{
		wfheight = 225;
	}else if( model.includes("amazx") || model.includes("aband7"))
	{
		wfheight = 250;
	}else{
		wfheight = 180;
	}
	
	switch(model) {
	  case "mb6":
	  case "mb7":
	  case "mb8":
			finalurl = adsofturl;
		break;
	  default:
		    finalurl = gtechurl;
	}
	
	switch(model) {
	   case "bip": case "bips": case "bip3": case "bipu": case "bip5": 
			endurl = `wfimg/preview${props.fileid}.gif`;
		break;
	case "mb4": case "mb5": case "mb6": case "mb7": case "mb8": 
			endurl = `${model}/${model}_${props.fileid}.gif`;
		break;	
	  default:
		    endurl = `${model}/images/${model}_${props.fileid}.gif`;
	}
	
    const StyledBadge = styled(Badge)(({ theme }) => ({
        '& .MuiBadge-badge': {
            right: 125,
            top: 20,
            padding: '2px 8px',
            borderRadius: '6px',
            borderBottom: '6px',
        },
    }));
	const navigate=useNavigate();
	const goToCarddetails = (cardId) => {
		localStorage.setItem("selectedCard", JSON.stringify(cardId));
		var attempts = parseInt(localStorage.getItem("attempts"));
		localStorage.setItem("attempts", ++attempts);
		
		navigate(`/${model}/details/${props.fileid}`);	
		 window.scroll(0, 0);
	}
    return (
        <div onClick = {()=>goToCarddetails(props)}>
            <StyledBadge>
                <Card sx={{ width: 180  }}>
                    <CardActionArea sx={{ backgroundColor: "none" }}>
                        <CardMedia
                            component="img"						   
                            image={ `${finalurl}${endurl}`}
                            alt="green iguana"
							sx={{ objectFit: 'contain', height: wfheight }}
							
                        />
                        <CardContent sx={{ p: 1 }} title={props.name}>
                            <Typography gutterBottom variant="subtitle1" component="div" noWrap={true} textAlign="center">
                                <span>{props.name}</span>
                            </Typography>
                            <Typography variant="body2" color="text.secondary" textAlign="center">                       
                                {props.author}
                            </Typography>
                        </CardContent>
                    </CardActionArea>
                </Card>
            </StyledBadge>
        </div>
    );
}